import UserMultipleSelector from "components/Templates/selectors/UserMultiSelector"
import { PEOPLE_SELECTOR } from "graphql/distribution-center/distribution-center.queries.gql"
import React from "react"

const DCPeopleResponsible = ({ ...props }) => {
  return (
    <UserMultipleSelector
      query={PEOPLE_SELECTOR}
      fill
      label="Point Of Contacts"
      group="*"
      path="pointOfContacts"
      renderTag={item => item?.fullName}
      renderText={item => item?.fullName}
      searchBy={["fullName", "number"]}
      {...props}
    />
  )
}

export default DCPeopleResponsible
